var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

var $ = require("./lib/qsa");
var leaflet = require("leaflet");
var colors = require("./lib/helpers/colors");

var mapContainer = $.one(".map-container");
var map = new leaflet.map(mapContainer, {
  zoomSnap: .1,
  scrollWheelZoom: false
});

map.focus = () => null;

leaflet.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
  subdomains: "abcd".split("")
}).addTo(map);

fetch("./ips.geojson").then(r => r.json()).then(function(ips) {
  var boundaries = new leaflet.GeoJSON(ips);
  boundaries.addTo(map);
  boundaries.setStyle({
    fillColor: colors.gray1,
    color: colors.gray1,
    fillOpacity: .1,
    opacity: .6,
    weight: 2
  });
  // map.fitBounds(boundaries.getBounds());
});

// generate a list of merged coordinate sets
var points = {};
for (var row of window.DATA) {
  var { address, coords } = row;
  if (!coords) continue;
  if (!points[coords]) points[coords] = [];
  points[coords].push(row);
}

var bounds = new leaflet.LatLngBounds();
for (var [key, values] of Object.entries(points)) {
  values.sort((a, b) => (a.closed || Infinity) - (b.closed || Infinity));
  var coords = key.split(",");
  bounds.extend(coords);
  var open = values.some(v => !v.closed);
  var marker = new leaflet.Marker(coords, {
    icon: new leaflet.DivIcon({
      iconSize: [8, 8],
      className: `school ${open ? "open" : "closed"}`
    })
  });
  marker.addTo(map);
  var tooltip = values.map(row => `
<h3 class="${row.closed ? "closed" : "open"}">${row.name}</h3>
${row.closed ? `Closed: ${row.closed}<br>` : ""}
Grades served: ${row.grades}<br>
${row.reason}
  `).join("<hr>");
  marker.bindPopup(tooltip);
}
map.fitBounds(bounds);

var zoomControl = map.zoomControl;
console.log(zoomControl);

map.on("popupopen", function() {
  map.removeControl(zoomControl);
})

map.on("popupclose", function() {
  map.addControl(zoomControl);
});